module.exports = __webpack_public_path__ + "img/google-store.2d3f3457.png";